var _circle, _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHealthDown(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10.5098,
    r: 10,
    fill: "#828282"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_942_2804",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 4,
    width: 14,
    height: 13
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.68359,
    y: 4.19385,
    width: 12.6316,
    height: 12.6316,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_942_2804)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.4721 12.6147L10.7353 9.90414L9.38004 11.2594C9.17829 11.4612 8.92829 11.562 8.63004 11.562C8.3318 11.562 8.0818 11.4612 7.88004 11.2594L5.10373 8.45677C5.00724 8.36028 4.9568 8.23967 4.95241 8.09493C4.94803 7.9502 4.99846 7.8252 5.10373 7.71993C5.20022 7.62344 5.32303 7.5752 5.47215 7.5752C5.62127 7.5752 5.74408 7.62344 5.84057 7.71993L8.63004 10.5094L9.98531 9.15414C10.1871 8.95239 10.4371 8.85151 10.7353 8.85151C11.0336 8.85151 11.2836 8.95239 11.4853 9.15414L14.209 11.8778V11.0357C14.209 10.8866 14.2594 10.7616 14.3603 10.6607C14.4612 10.5598 14.5862 10.5094 14.7353 10.5094C14.8844 10.5094 15.0094 10.5598 15.1103 10.6607C15.2112 10.7616 15.2616 10.8866 15.2616 11.0357V13.141C15.2616 13.2901 15.2112 13.4151 15.1103 13.516C15.0094 13.6169 14.8844 13.6673 14.7353 13.6673H12.63C12.4809 13.6673 12.3559 13.6169 12.255 13.516C12.1542 13.4151 12.1037 13.2901 12.1037 13.141C12.1037 12.9919 12.1542 12.8669 12.255 12.766C12.3559 12.6651 12.4809 12.6147 12.63 12.6147H13.4721Z",
    fill: "black"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHealthDown);
export default __webpack_public_path__ + "static/media/health_down.642cbdd2c48a4900b91854533f69bd44.svg";
export { ForwardRef as ReactComponent };